import { useState } from 'react';

const faqs = [
  {
    q: 'What is an AllChinaBuy Spreadsheet?',
    a: 'An AllChinaBuy spreadsheet is a curated, regularly updated list of products available through the AllChinaBuy platform. It organizes items by category, brand, seller rating, and price — making it dramatically easier to find quality products without spending hours searching manually.',
  },
  {
    q: 'How often is the spreadsheet updated?',
    a: 'Our AllChinaBuy spreadsheet is updated daily. We continuously add new finds, remove outdated listings, and refresh seller ratings to ensure you always have access to the most current and reliable product information.',
  },
  {
    q: 'How do I compare sellers using the spreadsheet?',
    a: 'Each product entry includes seller ratings, price information, and QC notes. Simply browse the category columns to compare prices and seller reputations side by side, helping you choose the best option for your needs.',
  },
  {
    q: 'Is shipping information included in the spreadsheet?',
    a: 'Yes! Our buying guides and safety tips sections include detailed shipping information, estimated delivery times, and recommendations for the most reliable shipping methods. This helps you plan your purchases and avoid unexpected delays.',
  },
  {
    q: 'Can beginners use the AllChinaBuy spreadsheet?',
    a: 'Absolutely. The spreadsheet is designed with beginners in mind. We provide step-by-step guides, safety tips, and clear category organization so anyone can start finding great products immediately — no prior experience needed.',
  },
  {
    q: 'How do I access the spreadsheet and start shopping?',
    a: 'Simply click any "allchinabuy sheet" or "buy it now" button on this page. You will be directed to kaspreadsheet.com where you can browse all categories, compare products, and start shopping with confidence.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 text-center mb-12">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <i
                  className={`ri-add-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-45' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}